import React from 'react';

const COPY = {
  en: {
    eyebrow: 'SERVICES / 2026',
    title: 'Systems that make the business easier to run.',
    lede: 'Six focused engagements. Each one starts with clarity about the operation and ends with a system the team can actually use.',
  },
  es: {
    eyebrow: 'SERVICIOS / 2026',
    title: 'Sistemas que hacen el negocio más fácil de operar.',
    lede: 'Seis compromisos enfocados. Cada uno comienza con claridad sobre la operación y termina con un sistema que el equipo realmente puede usar.',
  },
};

const ServicesHeroV2 = ({ lang = 'en' }) => {
  const t = COPY[lang] || COPY.en;
  return (
    <section className="iv2-services-hero" data-testid="iv2-services-hero">
      <div className="iv2-container">
        <p className="iv2-section-eyebrow">{t.eyebrow}</p>
        <h1 className="iv2-services-hero-title" data-testid="iv2-services-hero-title">
          {t.title}
        </h1>
        <p className="iv2-services-hero-lede">{t.lede}</p>
      </div>
    </section>
  );
};

export default ServicesHeroV2;
